@if (!reviewState) {
<div class="full-width full-height d-flex-center space-between flex-direction-column cq-slideshow">
    @if (commonQuestionnaireService.createMode && cstQuestionnaireService.currentSection) {
    <div class="section-header w-100 text-center m-b-20 d-flex-center justify-center">
        <div>SECTION {{ cstQuestionnaireService.currentSection.number }} . {{ cstQuestionnaireService.currentSection.section }}</div>
        @if (cstQuestionnaireService.currentSection.section || cstQuestionnaireService.currentSection.description) {
        <div class="m-t-negative-14">
            <span
                (click)="showDescription()"
                class="fs-18 ds-icon-info info-icon m-l-2"
            ></span>
        </div>
        }
    </div>
    } @if (!commonQuestionnaireService.createMode && !commonQuestionnaireService.reviewMode && customerQuestionnaireService.getQuestion()) {
    <div class="section-title fs-12 d-flex-center justify-center m-t-15">
        <div>{{ customerQuestionnaireService.getCurrentSectionTitle() }}</div>
    </div>
    } @if (!commonQuestionnaireService.createMode && entity && entity.entity && cstQuestionnaireService.instanceOfQuestion(entity.entity) &&
    entity.entity.cifc_review && !entity.entity.cifc_review.solved && !entity.entity.cifc_review.answered) {
    <div class="d-flex align-start justify-center flex-direction-column m-t-56 width-p-50 cifc-review-banner">
        <div class="d-flex-center full-width">
            <span class="d-flex align-baseline height-p-75 m-l-10 ds-icon-validation_error warning-icon fs-28"></span>
            <p class="p-16 m-0 letter-spacing-0">
                {{ getReviewBannerMessage(entity.entity.cifc_review.notification_type) }}<br />
                {{ entity.entity.cifc_review.reason ? entity.entity.cifc_review.reason : '-' }}
            </p>
        </div>
    </div>
    } @if (commonQuestionnaireService.createMode) {
    <div class="width-p-50">
        <app-question-header [entity]="entity"></app-question-header>
    </div>
    }
    <div
        class="full-width full-height d-flex align-start justify-center overflow-y-auto"
        [ngClass]="{ 'height-p-60 align-start': reviewState }"
    >
        <div class="d-flex-center">
            <div
                class="previous-question m-20 width-32 height-32"
                [ngStyle]="{ visibility: checkAvailability('previous') ? 'hidden' : 'visible' }"
            >
                <button
                    mat-icon-button
                    class="prev-button"
                    [disabled]="checkAvailability('previous')"
                    (click)="checkDirection('previous')"
                    disableRipple
                >
                    <mat-icon id="prev_icon_slideshow">chevron_left</mat-icon>
                </button>
            </div>
        </div>
        @if (entity && entity.entity) {
        <div class="question-panel p-15 width-p-50 m-t-56">
            @if (commonQuestionnaireService.createMode && cstQuestionnaireService.instanceOfSection(entity?.entity)) {
            <app-section-create></app-section-create>
            } @if (parseEntityAsQuestion(entity?.entity)?.type_id === QuestionTypesEnum.FREE) {
            <app-multiline-text [question]="parseEntityAsQuestion(entity.entity)"></app-multiline-text>
            } @if (parseEntityAsQuestion(entity?.entity)?.type_id === QuestionTypesEnum.FORM) {
            <app-form [question]="parseEntityAsQuestion(entity.entity)"></app-form>
            } @if (parseEntityAsQuestion(entity?.entity)?.type_id === QuestionTypesEnum.MULTIPLE) {
            <app-multiple-selection [question]="parseEntityAsQuestion(entity.entity)"></app-multiple-selection>
            } @if (parseEntityAsQuestion(entity?.entity)?.type_id === QuestionTypesEnum.SINGLE) {
            <app-single-selection [question]="parseEntityAsQuestion(entity.entity)"></app-single-selection>
            } @if (parseEntityAsQuestion(entity?.entity)?.type_id === QuestionTypesEnum.MATRIX) {
            <app-matrix [question]="parseEntityAsQuestion(entity.entity)"></app-matrix>
            }
        </div>
        }
        <div class="d-flex-center">
            <div
                class="next-question width-32 height-32 m-20"
                [ngStyle]="{ visibility: checkAvailability('next') ? 'hidden' : 'visible' }"
            >
                <button
                    mat-icon-button
                    class="next-button"
                    [disabled]="checkAvailability('next')"
                    (click)="checkDirection('next')"
                    disableRipple
                >
                    <mat-icon id="next_icon_slideshow">chevron_right</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
} @if (reviewState) {
<div class="full-width full-height d-flex-center space-between flex-direction-column overflow-y-auto m-b-15">
    @for (question of commonQuestionnaireService.reviewQuestionsSubject | async; track question; let i = $index) {
    <div class="d-flex-center justify-center full-width flex-direction-column m-t-56">
        <!--        Review container-->
        @if (reviewPanelOpen && reviewPanelOpen.length && reviewPanelOpen[i]) {
        <div class="d-flex align-start justify-center flex-direction-column height-p-100 width-p-50 m-b-5 review-container">
            <div class="d-flex-center full-width p-l-20 p-r-20 p-t-10">
                <p class="review-title width-p-30 field-label text-ellipsis m-r-40 height-p-65 letter-spacing-0">CIFC review action</p>
                <mat-radio-group
                    class="d-flex flex-direction-column"
                    color="primary"
                >
                    @for (option of reviewerOptions | keyvalue; track option) {
                    <mat-radio-button
                        [value]="option.value"
                        (change)="onReviewNotificationTypeChange(question, option.key, i)"
                        [checked]="!question.cifc_review?.solved && question?.cifc_review?.notification_type === option.key"
                    >
                        {{ option.value }}
                    </mat-radio-button>
                    }
                </mat-radio-group>
            </div>
            <div class="d-flex-center full-width p-l-20 p-r-20">
                <p class="width-p-30 field-label text-ellipsis m-r-40">Message</p>
                <mat-form-field
                    appearance="outline"
                    class="input-form-field m-t-10 width-p-55"
                >
                    <input
                        (input)="onReviewReasonChange($event, question, i)"
                        [value]="!question.cifc_review || question.cifc_review?.solved ? '' : question.cifc_review.reason"
                        matInput
                        [disabled]="!commonQuestionnaireService.displayOkCifc[i]"
                        maxlength="500"
                        type="text"
                        placeholder="Type here"
                        required
                    />
                </mat-form-field>
            </div>
        </div>
        }
        <!--        Question header-->
        <div class="width-p-50">
            <app-question-header
                [reviewMode]="true"
                [index]="i"
                [entity]="{ entity: question }"
                (questionReviewPanelOpen)="toggleReviewPanel($event, i)"
            >
            </app-question-header>
        </div>
        <!--        Question panel-->
        @if (question) {
        <div class="question-panel p-15 width-p-50 max-hp-100">
            @if (question.type_id === QuestionTypesEnum.FREE) {
            <app-multiline-text
                [id]="question.id"
                [question]="question"
                [questionIndex]="i"
            ></app-multiline-text>
            } @if (question.type_id === QuestionTypesEnum.FORM) {
            <app-form
                [id]="question.id"
                [question]="question"
                [questionIndex]="i"
            ></app-form>
            } @if (question.type_id === QuestionTypesEnum.MULTIPLE) {
            <app-multiple-selection
                [id]="question.id"
                [question]="question"
                [questionIndex]="i"
            ></app-multiple-selection>
            } @if (question.type_id === QuestionTypesEnum.SINGLE) {
            <app-single-selection
                [id]="question.id"
                [question]="question"
                [questionIndex]="i"
            ></app-single-selection>
            } @if (question.type_id === QuestionTypesEnum.MATRIX) {
            <app-matrix
                [id]="question.id"
                [question]="question"
                [questionIndex]="i"
            ></app-matrix>
            }
        </div>
        }
    </div>
    }
</div>
}
